import { render, staticRenderFns } from "./Organizations.vue?vue&type=template&id=3ae1c190&scoped=true"
import script from "./Organizations.vue?vue&type=script&lang=js"
export * from "./Organizations.vue?vue&type=script&lang=js"
import style0 from "./Organizations.vue?vue&type=style&index=0&id=3ae1c190&prod&lang=scss&scoped=true"
import style1 from "./Organizations.vue?vue&type=style&index=1&id=3ae1c190&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae1c190",
  null
  
)

export default component.exports